export const environment = {
  production: true,
  name: 'production',

  apiUrl: 'https://apierp.skysoftebs.com',
  websocketUrl: 'wss://apierp.skysoftebs.com',

  // enableLogs: false
  enableLogs: true
};